<template>
  <div class="paymentInput">
    <app-loading class="loading--lock" :isLoading="lock" />
    <div v-if="lock" class="paymentInput__cover"></div>
    <h3 class="paymentInput__title">申込み内容</h3>
    <div class="paymentInput__box">
      <input-item :item="item" :user="user" :price="price" />
    </div>
    <!-- <payment-tab :list="tabList" :active="activeTab" @active="activeTab = $event" /> -->
    <!-- クレジットカード -->
    <div class="paymentInput__credit">
      <template v-if="showCredit">
        <!-- クレジットカード情報がある場合 -->
        <template v-if="showRegisterdCredit">
          <h3 class="paymentInput__title">お支払い情報</h3>
          <div class="paymentInput__box">
            <credit-card-form-registered
              :input="input"
              :option="option"
              :card="card"
              @change="changeInput"
              @new-credit="showRegisterdCredit = false"
            />
          </div>
          <base-button text="登録済みのカードで支払う" type="fill" class="registerd" @click="toggleModal" />
        </template>
        <!-- 新規クレジットカード -->
        <template v-else>
          <h3 class="paymentInput__title">お支払い情報を{{ hasRegisterdCredit ? '変更' : '追加' }}</h3>
          <div class="paymentInput__box">
            <credit-card-form
              :input="input"
              :option="option"
              @change="changeInput"
              @error="setIsValidInput"
            />
          </div>
          <div class="paymentInput__foot">
            <base-button v-if="hasRegisterdCredit" text="戻る" @click="showRegisterdCredit = true" />
            <base-button
              :text="hasRegisterdCredit ? '変更' : '支払う'"
              type="fill"
              :disabled="!isValidInput"
              @click="toggleModal"
            />
          </div>
        </template>
      </template>
      <template v-else>
        読み込み中<span class="paymentInput__loading"></span>
      </template>
    </div>
    <!-- 確認モーダル -->
    <app-modal-simple
      title
      :active="showModal"
      @close="toggleModal()"
      location-path="ga_location"
      :showheader="true"
      :showfooter="false"
      class="simple"
    >
      <div slot="content" class="modalBody">
        <div class="modalBody__title">申込み内容の確認</div>
        <dl class="modalBody__dl">
          <dt class="modalBody__dt">メニュー</dt>
          <dd class="modalBody__dd">{{ item.name }}</dd>
          <dt class="modalBody__dt">申込日</dt>
          <dd class="modalBody__dd">{{ item.date }}({{ item.dayOfWeek}})</dd>
          <dt class="modalBody__dt">価格</dt>
          <dd class="modalBody__dd">
            10分まで¥{{ price | addComma }}(税込)、<br>
            延長は1分毎 ¥100(税込)
          </dd>
          <dt class="modalBody__dt">お支払い方法</dt>
          <dd class="modalBody__dd">クレジットカード</dd>
          <dt class="modalBody__dt">カード番号</dt>
          <dd class="modalBody__dd">{{ showRegisterdCredit ? trimCardNum(card.number) : trimCardNum(input.ccNumber) }}</dd>
          <dt class="modalBody__dt">カード有効期限</dt>
          <dd v-if="showRegisterdCredit" class="modalBody__dd">20{{ card.expirationYear }}/{{ card.expirationMonth }}</dd>
          <dd v-else class="modalBody__dd">20{{ input.ccExpirationYear }}/{{ input.ccExpirationMonth }}</dd>
        </dl>
        <div class="modalBody__notice">※商品のご提供時期、お支払い時期、キャンセルについては<a href="https://ulmar.jp/legal" target="_blank">こちら</a>をご確認ください。</div>
        <div class="modalBody__foot">
          <base-button text="戻る" @click="toggleModal()" />
          <base-button text="支払いを確定" type="fill" :disabled="lock"
            @click="showRegisterdCredit ? paymentRequest() : handleSubmit()"
          />
        </div>
      </div>
    </app-modal-simple>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import axios from 'axios'
import InputItem from '../partials/InputItem'
// import PaymentTab from '../partials/PaymentTab'
import CreditCardFormRegistered from '../partials/CreditCardFormRegistered'
import CreditCardForm from '../partials/CreditCardForm'
import BaseButton from '../partials/BaseButton'
import getUlmarEnvDomain from '@/utils/getUlmarEnvDomain'

export default {
  name: 'UlmarPaymentInput',
  components: {
    InputItem,
    // PaymentTab,
    CreditCardFormRegistered,
    CreditCardForm,
    BaseButton,
  },
  props: {
    item: Object,
    user: Object,
    formParam: Object,
    sbps: Object,
    url: Object,
  },
  data() {
    return {
      // 二重送信防止用
      lock: false,
      // お支払いする金額（税込み）
      price: this.item.amount,
      // tabList: [
      //   { value: 'credit', text: 'クレジットカード' },
      // ],
      // activeTab: 'credit',
      showModal: false,
      // 登録済みのクレジットカードがあるかどうか
      hasRegisterdCredit: false,
      // クレジットカード登録済み画面を表示するかどうか
      showRegisterdCredit: false,
      // form 入力値
      input: {
        ccNumber: '',
        ccExpiration: '',
        ccExpirationYear: '',
        ccExpirationMonth: '',
        // numberPayments: '1',
        securityCode: '',
      },
      // input が有効か
      isValidInput: false,
      // form オプション
      option: {
        // numberPayments: [
        //   { value: '1', text: '一括払い' },
        // ],
      },
      registCredit: true,
      // SBPSワンタイムトークン関連のレスポンス
      sbpsResponse: {},
      // ユルマールの環境変数
      envDomain: getUlmarEnvDomain(),
      // クレカの表示
      showCredit: true,
    }
  },
  computed: {
    // 選択した支払い回数のテキスト取得
    // numberPaymentsText() {
    //   return this.option.numberPayments.find(v => v.value === this.input.numberPayments).text
    // },
    ...mapState({
      card: state => state.payment.academy,
    }),
  },
  created() {
    this.getPaymentInfo()
  },
  methods: {
    //カード情報取得
    getPaymentInfo() {
      this.showCredit = false
      this.$store.dispatch(type.GET_PAYMENT_INFO_ULMAR, { userId: this.user.userId })
      .then(()=> {
        this.showRegisterdCredit = true
        this.hasRegisterdCredit = true
      })
      .finally(() => {
        this.showCredit = true
      })
    },
    // input を変更
    changeInput(payload) {
      if (payload.target === 'ccExpiration') {
        // 年と月の両方が入力されていたら更新
        this.input.ccExpiration =
          payload.value.year && payload.value.month ? `20${payload.value.year}${payload.value.month}` : ''
        this.input.ccExpirationYear = payload.value.year
        this.input.ccExpirationMonth = payload.value.month
      } else {
        this.input[payload.target] = payload.value
      }
    },
    // バリデーション結果（全て値がある、かつ、エラーがないと true）
    setIsValidInput(error) {
      const obj = this.input
      const hasValue = Object.keys(obj).every(key => obj[key])
      this.isValidInput = hasValue && !error
    },
    toggleModal() {
      this.showModal = !this.showModal
      if (this.showModal) {
        // GA送信
        window.gtag('event', 'PaymentCheckModal', {
          page_location: location.origin + location.pathname + '/paymentcheck'
        })
      }
    },
    trimCardNum(str = '', length = 0) {
      return `************${str.slice(-4)}`
    },
    // SBPSのワンタイムトークンの処理（詳しくはSBPSのドキュメントを見てね）
    handleSubmit() {
      this.lock = true
      let data = {
        merchantId: this.sbps.merchantId,
        serviceId: this.sbps.serviceId,
        ccNumber: this.input.ccNumber,
        ccExpiration: this.input.ccExpiration,
        securityCode: this.input.securityCode
      }
      window.com_sbps_system.generateToken(data, this.afterGenerateToken)
    },
    // ワンタイムトークンのコールバック
    afterGenerateToken(response) {
      if (response.result == 'OK') {
        new Promise(resolve => {
          this.sbpsResponse = Object.assign({}, response.tokenResponse)
          resolve()
        }).then(() => {
          this.paymentRequest()
        })
      } else {
        this.lock = false
      }
    },
    // 決済要求API
    paymentRequest() {
      this.lock = true
      const url = this.url.checkPaymentApi
      const param = {
        'token': this.sbpsResponse.token,
        'tokenKey': this.sbpsResponse.tokenKey,
        'user_id': this.user.userId,
        'order_id': this.user.orderId,
        'price': this.price,
        // 'divide_times': this.input.numberPayments,
        'cust_manage_flg': this.registCredit ? 1 : 0,
      }
      axios.post(url, param).then(res => {
        if (res.data.response === 'OK') {
          window.location.href = `${res.data.complete_url}`
        } else {
          const errorText = `${res.data.errorTitle}\n${res.data.errorMessage}`
          const messageParam = { message: errorText, type: 'error', duration: 5000, showClose: true }
          this.toggleModal()
          this.lock = false
          this.$message({ ...messageParam })
        }
      }).catch(error => {
        console.log(error)
        this.lock = false
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../sass/commons/commonVariables.scss';

.paymentInput {
  &__cover {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100010;
  }
  &__title {
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    color: #FFFFFF;
    background: #CDB0A1;
    border-radius: 8px 8px 0 0;
    padding: 7px 0;
    margin: 0;
  }
  &__box {
    background: #FFFFFF;
    border-radius: 0 0 8px 8px;
    padding: 16px;
    margin: 0 auto 16px;
  }
  &__credit,
  &__convenience {
    margin: 0 auto;
  }
  &__regist {
    margin-bottom: 36px;
    display: inline-flex;
    justify-content: flex-start;
  }
  &__foot {
    display: flex;
    margin-top: 24px;
    .baseButton + .baseButton {
      margin-left: 16px;
    }
  }
  .modal /deep/ {
    .modal__content {
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
      border-radius: 16px;
      max-width: 385px;
      font-family: 'M PLUS Rounded 1c', "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "メイリオ", Meiryo, sans-serif;
    }
    .close svg {
      fill: $academy_purple;
    }
  }
  &__loading {
    &::before {
      content: '.';
      animation: loading 4s infinite;
      @keyframes loading {
        0% { content: '.'; }
        25% { content: '..'; }
        50% { content: '...'; }
        75% { content: '....'; }
      }
    }
  }
  .baseButton {
    border-color: #B1816D;
    color: #B1816D;
    font-size: 15px;
    font-weight: 500;
    line-height: 49px;
    &--fill,
    &--fill:hover {
      background: #B1816D;
      max-width: none;
      color: #fff;
    }
    &--fill:hover {
      opacity: 0.8;
    }
    &--disabled {
      background: #ECE0CD;
    }
    &.registerd {
      margin-top: 40px;
    }
  }
}
.modalBody {
  font-size: 13px;
  &__title {
    color: #FFFFFF;
    font-size: 15px;
    line-height: 1;
    text-align: center;
    margin: 0 0 8px;
    padding: 16px 0 17px;
    background: #B1816D;
    border-radius: 16px 16px 0 0;
  }
  &__dl {
    margin: 0 0 8px;
    padding: 0 24px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  &__dt,
  &__dd {
    margin: 0;
    padding: 10px 0;
    border-top: 1px dashed #FFF9EF;
    &:first-of-type {
      border: none;
    }
  }
  &__dt {
    flex: 0 0 120px;
    color: #CDB0A1;
  }
  &__dd {
    flex: 1 1 calc(100% - 120px);
  }
  &__notice {
    margin: 0 0 20px;
    padding: 0 24px;
  }
  &__foot {
    display: flex;
    padding: 0 16px 16px;
  }
  .baseButton {
    margin: 0 16px 0 0;
    &:last-child {
      margin-right: 0;
    }
  }
}
.loading {
  background: #B1816D;
  &--lock {
    position: fixed;
    z-index: 100011;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Ulmar/pages/PaymentInput.vue